import React, { useState } from "react";
import "./ImageTooltip.css";
import { Modal } from "antd";

const ImageTooltip = ({ image, title, link }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="chant-image-tooltip-container">
      {link && (
        <div>
          <a href={link} target="#">
            {title}
          </a>{" "}
        </div>
      )}
      <div className="chant-image-tooltip-image-container">
        <img
          onClick={() => setOpen(true)}
          className="chant-image-tooltip-thumbnail"
          src={image}
          alt="stripe screenshot"
          height={15}
        />
      </div>

      <Modal
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        centered
        width={1000}
        height={800}
      >
        <img
          style={{ width: "100%", height: "100%", objectFit: "contain" }}
          src={image}
          alt="stripe screenshot"
        />
      </Modal>
    </div>
  );
};

export default ImageTooltip;
